import react, { useState, createContext } from 'react';
export const ContextDateSearch = createContext({ valueDateSearch: [], onDateSearch: () => { } });

export const SearchDateProvider = ({ children }) => {
    const [valueDateSearch, setValueDateSearch] = useState([]);

    const handleSearch = (newData) => {
        setValueDateSearch(newData);
        localStorage.setItem("valueDateSearch", JSON.stringify(newData));
    }
    return <ContextDateSearch.Provider value={{ valueDateSearch: valueDateSearch, onDateSearch: handleSearch }}>{children}</ContextDateSearch.Provider>;
}